export default class AirService {

    constructor(apiUrl = "https://api.iot.freeutg.com") {
        this.apiUrl = apiUrl;
    }

    async fetchDevices(types = ["dragino-aq"]) {
        const response = await fetch(this.apiUrl + "/devices/?type=" + types.join(","));
        return await response.json();
    }

    async getDevice(devEUI) {
        const devices = await this.fetchDevices();

        for (let i in devices) {
            if (devices[i].devEUI == devEUI) {
                return devices[i];
            }
        }

        return null;
    }
}